module.exports = __webpack_public_path__ + "static/media/ic_account_arrow_down.6d2f8387.svg";